const state = {
    currentTheme: localStorage.getItem('theme') || 'light-theme',
    themes: [
        { key: 'light-theme', name: '亮色主题', nameEn: 'Light Theme' },
        { key: 'dark-theme', name: '暗色主题', nameEn: 'Dark Theme' },
        { key: 'tech-blue-theme', name: '蓝色科技', nameEn: 'Tech Blue' }
    ]
}

const mutations = {
    SET_THEME(state, theme) {
        state.currentTheme = theme
        localStorage.setItem('theme', theme)
        document.documentElement.className = theme
    }
}

const actions = {
    setTheme({ commit }, theme) {
        commit('SET_THEME', theme)
    }
}

const getters = {
    currentTheme: state => state.currentTheme,
    themes: state => state.themes
}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}
